import { render, staticRenderFns } from "./TrangDanhSachVaiTro.vue?vue&type=template&id=4a672ec6&"
import script from "./TrangDanhSachVaiTro.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports